import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Carlos Vega",
    location: "Madrid",
    vehicle: "BMW M3 Competition · 2022",
    text: "Quería un M3 con un equipamiento muy específico que en España no encontraba. Elecars lo localizó en Múnich en 10 días, revisó el coche en persona y me lo entregó en Madrid sin un solo problema.",
  },
  {
    name: "Laura Fernández",
    location: "Barcelona",
    vehicle: "Mercedes Sprinter · 2021",
    text: "Importé una furgoneta para mi negocio de reparto. El proceso fue impecable: me enviaron fotos del taller donde la revisaron y todos los documentos antes de pagar. Profesionales de verdad.",
  },
  {
    name: "Javier Ortiz",
    location: "Valencia",
    vehicle: "Audi RS6 Avant · 2020",
    text: "Ahorré más de 18.000€ respecto al precio en España. Pero lo que más valoro es la tranquilidad. Sabía en todo momento qué pasaba con mi coche. Recomendados al 100%.",
  },
  {
    name: "María Calvo",
    location: "Sevilla",
    vehicle: "Audi Q5 · 2023",
    text: "Buscaba un familiar premium con bajo kilometraje. Me presentaron 4 opciones detalladas, eligieron la mejor conmigo y se encargaron de todo. No tuve que viajar a Alemania.",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonios"
      className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-16"
        >
          <span className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Testimonios</span>
          <h2 className="font-heading mt-6 text-3xl sm:text-5xl font-light tracking-tight text-[#FFFFF0] leading-tight">
            Clientes que ya conducen su coche alemán.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="relative bg-white/[0.02] border border-white/5 p-8 sm:p-10 hover:border-[#D4AF37]/30 transition-all duration-500"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-8 h-8 text-[#D4AF37]/40 mb-6" strokeWidth={1} />
              <p className="font-heading text-lg sm:text-xl font-light text-[#FFFFF0] leading-relaxed mb-8 italic">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-white/10">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#8a6f1f] flex items-center justify-center font-heading text-black font-semibold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="font-heading text-sm font-medium text-[#FFFFF0]">{t.name}</p>
                  <p className="text-xs text-[#A3A3A3] mt-0.5">{t.location} · <span className="text-[#D4AF37]">{t.vehicle}</span></p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
